<template>
  <div class="container col-md-12">
    <h1>Annual Cost calculator</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>
    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content class="md-padding">
        <table class="table table-striped table-bordered">
          <tr>
            <th>Hire Age</th>
            <td>{{ calcData.hire_age | numeral("0.1") }}</td>
          </tr>
          <tr>
            <th>Hire Age Check</th>
            <td>{{ calcData.hire_age_check }}</td>
          </tr>
          <tr>
            <th>Age Data Date</th>
            <td>{{ calcData.age_data_date | numeral("0.1") }}</td>
          </tr>
          <tr>
            <th>Labor Costs Now</th>
            <td>{{ calcData.labor_costs_now | currency }}</td>
          </tr>
          <tr>
            <th>Labor Costs 5 years from now</th>
            <td>{{ calcData.labor_costs_5years | currency }}</td>
          </tr>
          <tr>
            <th>Medical Costs Now</th>
            <td>{{ calcData.medical_costs_now | currency }}</td>
          </tr>
          <tr>
            <th>Life Ins Costs Now</th>
            <td>
              {{ calcData.life_costs_now | currency({ fractionCount: 3 }) }}
            </td>
          </tr>
          <tr>
            <th>Total Benefits Costs Now</th>
            <td>{{ calcData.total_benefits_costs_now | currency }}</td>
          </tr>
          <tr>
            <th>Medical Costs 5 years from now</th>
            <td>{{ calcData.medical_costs_5years | currency }}</td>
          </tr>
          <tr>
            <th>Life Ins Costs 5 years from now</th>
            <td>
              {{ calcData.life_costs_5years | currency({ fractionCount: 3 }) }}
            </td>
          </tr>
          <tr>
            <th>Total Benefits Costs 5 years from now</th>
            <td>{{ calcData.total_benefits_costs_5years | currency }}</td>
          </tr>
          <tr>
            <th>Absenteeism Costs Now</th>
            <td>{{ calcData.absenteeism_costs_now | currency }}</td>
          </tr>
          <tr>
            <th>Absenteeism Costs 5 years from now</th>
            <td>{{ calcData.absenteeism_costs_5years | currency }}</td>
          </tr>
        </table>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_ANNUAL_COST, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
export default {
  data() {
    return {
      calcAction: CALC_ANNUAL_COST,
      inputCategories: [INPUT_TYPES.PARTICIPANT, INPUT_TYPES.PLAN_BASIC_DATA]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
